// extracted by mini-css-extract-plugin
export default {"container":"Table_container__BsofP","scrollBox":"Table_scrollBox__OK9sf"};